import { CollectionReference, collection, getDocs, getFirestore, query, where } from 'firebase/firestore';

import { toast } from '@/components/Toaster/Toast';

import { SystemInDatabase } from './getFirebaseSystemByConfigId';
import { safePromise } from './safePromise';

export const getFirebaseSystemsByOrganizationId = async (id: string): Promise<SystemInDatabase[] | undefined> => {
  // TODO: Should we use the initialized firestore from firebaseConfig?
  const firestore = getFirestore();

  const systemsRef = collection(firestore, '_systems') as CollectionReference<SystemInDatabase>;
  const systemsQuery = query(systemsRef, where('organization', '==', id));

  const [querySnapshot, error] = await safePromise(getDocs(systemsQuery));
  if (error) {
    toast({
      variant: 'error',
      title: 'Something went wrong',
      description: 'Please try again later',
    });

    return undefined;
  }

  if (querySnapshot.empty) {
    toast({
      variant: 'error',
      title: 'No systems found',
      description: 'Please contact support',
    });

    return undefined;
  }

  return querySnapshot.docs.map((doc) => ({ ...doc.data(), id: doc.id }));
};
